import { WORK_ORDER_STATUS_VALUES, WorkOrderTableRow } from "./types";

const MOCK_ROWS: Omit<WorkOrderTableRow, "status">[] = [
  {
    id: 1,
    workOrderId: "WO-5501",
    customerName: "TAVGA_TRANSPORT",
    vehicle: "REFRIGERATED_TRAILER_12M",
    currentStage: "METALWORK",
    progress: 10,
    priority: "MEDIUM",
  },
  {
    id: 2,
    workOrderId: "WO-5502",
    customerName: "SHLOMO_LOGISTICS",
    vehicle: "CLOSED_BOX_TRUCK",
    currentStage: "PAINT",
    progress: 25,
    priority: "HIGH",
  },
  {
    id: 3,
    workOrderId: "WO-5503",
    customerName: "GAL_COLD_CHAIN",
    vehicle: "REFRIGERATED_SEMI",
    currentStage: "PAINT",
    progress: 65,
    priority: "HIGH",
  },
  {
    id: 4,
    workOrderId: "WO-5504",
    customerName: "TAVGA_TRANSPORT",
    vehicle: "CLOSED_BOX_TRUCK",
    currentStage: "QUALITY_CONTROL_STAGE",
    progress: 80,
    priority: "MEDIUM",
  },
  {
    id: 5,
    workOrderId: "WO-5505",
    customerName: "SHLOMO_LOGISTICS",
    vehicle: "REFRIGERATED_TRAILER_12M",
    currentStage: "QUALITY_CONTROL_STAGE",
    progress: 90,
    priority: "NORMAL",
  },
  {
    id: 6,
    workOrderId: "WO-5506",
    customerName: "GAL_COLD_CHAIN",
    vehicle: "REFRIGERATED_SEMI",
    currentStage: "QUALITY_CONTROL_STAGE",
    progress: 100,
    priority: "NORMAL",
  },
];

export const MOCK_WORK_ORDERS: WorkOrderTableRow[] = MOCK_ROWS.map((row, index) => ({
  ...row,
  status: WORK_ORDER_STATUS_VALUES[index],
}));
